import React, { useRef, useState, useEffect } from "react";
import { useDrop } from "react-dnd";
import { Document, Page, pdfjs } from "react-pdf";
import DraggableResizableField from "./DraggableResizableField";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { Spin } from "antd";
import SmallSpinner from "../../loading/SmallSpinner";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const PDFViewerGPT1 = ({ pdfUrl }) => {
  const pdfContainerRef = useRef(null);
  const [numPages, setNumPages] = useState(0);
  const [pdfDimensions, setPdfDimensions] = useState({ width: 0, height: 0 });
  const [pdfScale, setPdfScale] = useState(1);
  const [containerWidth, setContainerWidth] = useState(1000);
  const [droppedField, setDroppedField] = useState(null);
  const [loading, setLoading] = useState(true);
  const onDocumentLoad = async ({ numPages }) => {
    setNumPages(numPages);

    if (!pdfUrl) return;

    try {
      // Load the PDF document
      const loadingTask = pdfjs.getDocument(pdfUrl);
      const pdf = await loadingTask.promise;

      if (!pdf) {
        console.error("PDF document is null");
        setLoading(false);
        return;
      }

      const firstPage = await pdf.getPage(1); // Get the first page

      if (!firstPage) {
        console.error("First page is null");
        setLoading(false);
        return;
      }

      // Use getViewport to get the correct height & width
      const viewport = firstPage.getViewport({ scale: 1.5 });
      const { width, height } = viewport;

      // Adjust dimensions
      //   setPdfDimensions({ width: width, height: height });

      setContainerWidth(width); // Ensure a reasonable width
      setLoading(false); // Set loading to false after the PDF is loaded
    } catch (error) {
      console.error("Error getting PDF page dimensions:", error);
      setLoading(false);
    }
  };
  return (
    <div
      style={{
        flex: 1,
        overflow: "auto",
        position: "relative",
        width: `${containerWidth}px`,
        margin: "0 auto",
        backgroundColor: "#f0f0f0",
      }}
    >
      <div ref={pdfContainerRef} style={{ position: "relative" }}>
        <Document file={pdfUrl} onLoadSuccess={onDocumentLoad}>
          {loading ? (
            <SmallSpinner />
          ) : (
            <>
              {[...Array(numPages)].map((_, index) => {
                const pageNumber = index + 1;
                return (
                  <div
                    key={pageNumber}
                    style={{
                      position: "relative",
                      width: `${containerWidth}px`,
                      height: `1100 px`,
                      marginBottom: "10px",
                    }}
                  >
                    <Page
                      pageNumber={pageNumber}
                      width={containerWidth}
                      renderAnnotationLayer={true}
                      renderTextLayer={true}
                    />

                    {/* Render sign fields only if in sign mode */}
                  </div>
                );
              })}
            </>
          )}
        </Document>
      </div>
    </div>
  );
};

export default PDFViewerGPT1;
